module.exports = window['shared-web'];